var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { ToggleSwitch } from './ToggleSwitch';
const ToggleSwitchStateful = (_a) => {
    var { buttonId, label, labelId, name, valueOn, valueOff, defaultOn = false, onChange } = _a, marginProps = __rest(_a, ["buttonId", "label", "labelId", "name", "valueOn", "valueOff", "defaultOn", "onChange"]);
    const [isChecked, setIsChecked] = React.useState(defaultOn);
    const onClick = () => {
        setIsChecked(!isChecked);
        if (onChange)
            onChange(!isChecked);
    };
    return (React.createElement(ToggleSwitch, Object.assign({ buttonId: buttonId, label: label, labelId: labelId, name: name, valueOn: valueOn, valueOff: valueOff, onClick: onClick, isChecked: isChecked }, marginProps)));
};
export { ToggleSwitchStateful };
//# sourceMappingURL=ToggleSwitchStateful.js.map